// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { initializeERPAuth } from "./mobile/initializeAuth";
import { getStorage, ref } from "firebase/storage";
import { resolveERPWorkspace, workspaceUploadPath } from './services/erpWorkspace';
import { getFunctions } from "firebase/functions"; // <--- Added import for Cloud Functions

// PASTE YOUR KEYS HERE
const firebaseConfig = {
  apiKey: "AIzaSyAmlFhHsPlyzSllcRWMimZ1BxBKfaBhbrI",
  authDomain: "exam-platform-v2.firebaseapp.com",
  databaseURL: "https://exam-platform-v2-default-rtdb.firebaseio.com",
  projectId: "exam-platform-v2",
  storageBucket: "exam-platform-v2.firebasestorage.app",
  messagingSenderId: "745181277731",
  appId: "1:745181277731:web:a4bbe0dd6aba35ccba4b96",
  measurementId: "G-ZKSSTBRB13"
};

const app = initializeApp(firebaseConfig);
export let db = getFirestore(app);
export let isReviewWorkspace = false;
export const resolveWorkspace = user => resolveERPWorkspace(user, id => getFirestore(app, id));
// AuthContext commits this only after its generation check; a slow prior
// account's token must never switch a newer session's database.
export function activateWorkspace(workspace) {
  db = workspace.db;
  isReviewWorkspace = workspace.isReview;
}
export const erpStorageRef = (storageInstance, path) => ref(storageInstance, workspaceUploadPath(path, { isReview: isReviewWorkspace, uid: auth.currentUser?.uid }));
export const auth = initializeERPAuth(app);
export const storage = getStorage(app); 
export const functions = getFunctions(app); // <--- Exported functions for schedulingServices
export default app;
